import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from '@angular/core';

import {environment} from "@numizmat/environments";
import {
  DeleteProfileRequest,
  DeleteProfileResponse,
  UpdateConfirmationMethodRequest,
  UpdateConfirmationMethodResponse,
  UpdateEmailRequest,
  UpdateEmailResponse,
  UpdatePasswordRequest,
  UpdatePasswordResponse
} from "@numizmat/services-models/account";

@Injectable({
  providedIn: 'root'
})
export class AccountSettingsApiService {
  private httpClient: HttpClient = inject(HttpClient);

  private accountSettingsController: string = 'accountSettings';

  public updateEmail(request: UpdateEmailRequest): Observable<UpdateEmailResponse> {
    const endpoint = `${environment.apiAccountUrl}/${this.accountSettingsController}/update-email`;
    return this.httpClient.patch<UpdateEmailResponse>(endpoint, request);
  }

  public updatePassword(request: UpdatePasswordRequest): Observable<UpdatePasswordResponse> {
    const endpoint = `${environment.apiAccountUrl}/${this.accountSettingsController}/update-password`;
    return this.httpClient.patch<UpdatePasswordResponse>(endpoint, request);
  }

  public updateConfirmationMethod(request: UpdateConfirmationMethodRequest): Observable<UpdateConfirmationMethodResponse> {
    const endpoint = `${environment.apiAccountUrl}/${this.accountSettingsController}/update-confirmation-method`;
    return this.httpClient.patch<UpdateConfirmationMethodResponse>(endpoint, request);
  }

  public deleteProfile(request: DeleteProfileRequest): Observable<DeleteProfileResponse> {
    const endpoint = `${environment.apiAccountUrl}/${this.accountSettingsController}/delete-profile`;
    return this.httpClient.patch<DeleteProfileResponse>(endpoint, request);
  }
}
